import { create } from 'zustand';
import type { LeaseFeature } from '../components/Map/hooks/useLeaseFeatures';
import type { Sublease } from '../types';

interface MapState {
  selectedLotId: string | null;
  selectedFeature: LeaseFeature | null;
  selectedSublease: Sublease | null;
  setSelectedLease: (lotId: string | null) => void;
  setSelectedFeature: (feature: LeaseFeature | null) => void;
  setSelectedSublease: (sublease: Sublease | null) => void;
}

export const useMapStore = create<MapState>((set) => ({
  selectedLotId: null,
  selectedFeature: null,
  selectedSublease: null,
  setSelectedLease: (lotId) => set({ selectedLotId: lotId }),
  setSelectedFeature: (feature) => set({ selectedFeature: feature }),
  setSelectedSublease: (sublease) => set({ selectedSublease: sublease })
}));